import {
  FormFieldWidget,
  FormM2MTableFieldWidget,
  http,
  ModelFieldType,
  SPI,
  ViewType,
  Widget,
  ValidatorInfo,
  ValidatorStatus,
  isValidatorSuccess,
  WidgetSubjection
} from '@kunlun/dependencies';
import AfterSalesRefundsReturn from './AfterSalesRefundsReturn.vue';
import { OioMessage, OioNotification } from '@kunlun/vue-ui-antd';
import { cloneDeep } from 'lodash-es';
import XLSX from 'xlsx';
import { stringifyToGraphql as commonStringifyToGraphql } from '../../../../utils/serialize';
import { FormM2mMultiAfterSalesRefundsReturnFieldWidget } from '../AfterSalesRefundsReturn';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Form,
    ttype: ModelFieldType.ManyToMany,
    widget: 'Table',
    name: 'returnDetailProxySaleSkus',
    model: [
      'deli.aries.merchant.DeliAriesMerchantBrandStoreReverseOrderCreate',
      'deli.aries.merchant.DeliAriesMerchantBrandStoreReverseOrderEdit'
    ],
    multi: true
  })
)
export class FormM2mMultiBuyerAfterSalesRefundsReturnFieldWidget extends FormM2mMultiAfterSalesRefundsReturnFieldWidget {
  
  @Widget.Reactive()
  protected get portActionBtnShow(){
    return{
      showImportBtn:false,
      showExportBtn:true
    }
  }
  
  @Widget.Reactive()
  protected get DoubleSourceFindInvisible(){
    return true;
  }
}
